var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-center"},[_c('Submissions',{attrs:{"defaultFilter":'pending'}}),_c('br'),(_vm.isPremium)?_c('GiftSubBatches',{attrs:{"filter":'pending'}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }